module.exports = __webpack_public_path__ + "static/img/RCB48V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RCB48V_1.png
// module id = wUyM
// module chunks = 0